import ListMobileScrollContainer from './listMobileScrollContainer.js'
import ListMobileScrollItem from './listMobileScrollItem.js'
import ListMobileScroll from './listMobileScrollLegacy.js'
import {GAP_SIZES} from './settings.js'

ListMobileScroll.Container = ListMobileScrollContainer
ListMobileScroll.Item = ListMobileScrollItem

export {GAP_SIZES as gapSizes}

export default ListMobileScroll
